import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { PaymentMethodUpdateComponent } from "../../payment-method-update/payment-method-update.component";
import { PaymentMethodUpdateGet } from '../../../../../core/interfaces/payment-interfaces';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-method-update-dialog',
  standalone: true,
  imports: [TranslocoPipe, PaymentMethodUpdateComponent, CommonModule],
  templateUrl: './payment-method-update-dialog.component.html',
  styleUrl: './payment-method-update-dialog.component.css'
})
export class PaymentMethodUpdateDialogComponent {
  modalDialogId: string = 'settings_modal_update_payment_method'

  clientSecret: string | undefined;

  openModal(paymentMethodUpdate: PaymentMethodUpdateGet): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      this.clientSecret = paymentMethodUpdate.client_secret;
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
    }
  }
}
